import * as React from 'react';

export interface VariableProps {
  variable: string;
}

const Variable: React.FC<VariableProps> = ({ variable }) => {
  // todo: implement client side variable loading
  return <span style={{ background: '#fafafa' }}>{variable}</span>;
};

export default Variable;
